/**
 * Footer country/language dropdown toggles.
 * Uses plain DOM listeners so the footer selectors work independently of header localization.
 */

function closeFooterLocalizationDropdowns(exceptDropdown) {
  document.querySelectorAll('[data-footer-localization-dropdown]').forEach((dropdown) => {
    if (dropdown === exceptDropdown) return;

    const panel = dropdown.querySelector('[data-footer-localization-panel]');
    const button = dropdown.querySelector('[data-footer-localization-trigger]');

    panel?.setAttribute('hidden', '');
    button?.setAttribute('aria-expanded', 'false');
  });
}

function initFooterLocalization() {
  document.querySelectorAll('[data-footer-localization-dropdown]').forEach((dropdown) => {
    if (dropdown.dataset.footerLocalizationReady === 'true') return;

    const button = dropdown.querySelector('[data-footer-localization-trigger]');
    const panel = dropdown.querySelector('[data-footer-localization-panel]');

    if (!button || !panel) return;

    dropdown.dataset.footerLocalizationReady = 'true';

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = !panel.hasAttribute('hidden');

      closeFooterLocalizationDropdowns();

      if (!isOpen) {
        panel.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

if (!window.__footerLocalizationListenersBound) {
  window.__footerLocalizationListenersBound = true;

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-footer-localization-dropdown]')) return;
    closeFooterLocalizationDropdowns();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeFooterLocalizationDropdowns();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFooterLocalization);
} else {
  initFooterLocalization();
}

document.addEventListener('shopify:section:load', initFooterLocalization);
